export const noUcidCookieName = 'noucid';

export const TAX_REGISTER_TYPE = 'RegisteredPerson';
export const TAX_UPDATE_REGISTRATION = 'Y';
export const TAX_PROFILE_UPDATE = 'taxonly';

export const INVALID_TAX_FIELD_CHARS_REGEX = /^[^\\<>[\]{}]*$/;
export const INVALID_NUM_TAX_FIELD_CHARS_REGEX = /^[eE+-.]*$/;
export const ONLY_DIGIT_TAX_FIELD_CHARS_REGEX = /[^\d]/g;
